import { Spinner } from "react-bootstrap";

type AppLoaderProps = {
  text?: string;
};

export default function AppLoader({ text = "Loading..." }: AppLoaderProps) {
  return (
    <div className="app-loader-overlay" role="status" aria-live="polite">
      <div className="app-loader-content">
        <Spinner
          animation="border"
          role="status"
          style={{ color: "#ff6900" }}
          aria-label="Loading"
        />
        <div className="app-loader-text">{text}</div>
      </div>
    </div>
  );
}

